import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyBOoXQKLk4NTUT2488IMCIYT8TuYuW2YrU",
  authDomain: "wendoeapp.firebaseapp.com",
  databaseURL: "https://wendoeapp.firebaseio.com",
  projectId: "wendoeapp",
  storageBucket: "wendoeapp.appspot.com",
  messagingSenderId: "652294262854"
};

firebase.initializeApp(config);

export const auth = firebase.auth();
export default firebase



// WEBPACK FOOTER //
// ./src/firebase.js